/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { LotBaseFragment } from '../../LotBasePage/types/lotBaseFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type LotScheduleQueryVariables = Types.Exact<{
  seoName: Types.Scalars['String']
}>

export type LotScheduleQuery = {
  __typename: 'Query'
  lotGroup: {
    __typename: 'LotGroup'
    id: number | null
    seoName: string | null
    name: string | null
    description: string | null
    address: string | null
    fullAddress: string | null
    schedulePath: string
    lotGroupUrl: string
    lotGroupPath: string
    notice: { __typename: 'HtmlRecord'; html: string; present: boolean }
    flyerImage: {
      __typename: 'ImageAttachment'
      id: number
      url: string
    } | null
    lots: Array<{
      __typename: 'Lot'
      lotGroupPosition: number | null
      latitude: number
      longitude: number
      id: number
      name: string
      active: boolean
      lotUrl: string
      lotPath: string
      address: string | null
      fullAddress: string
      facebook: string | null
      instagram: string | null
      twitter: string | null
      tiktok: string | null
      website: string | null
      referralEnabled: boolean
      image: {
        __typename: 'LotImage'
        horizontalStretch: string
        medium: string
        original: string | null
        present: boolean
      } | null
      foodImage: { __typename: 'LotFoodImage'; medium: string } | null
    }> | null
    image: { __typename: 'LotGroupImage'; medium: string } | null
    locationSchedule: Array<{
      __typename: 'LocationSchedule'
      id: string
      dateAlias: string
      date: any
      locations: Array<{
        __typename: 'Location'
        id: number
        startTime: any
        endTime: any
        workStatus: Types.LocationWorkStatus
        workStatusHuman: string
        allowOrders: boolean
        customerUrl: string
        truck: {
          __typename: 'Truck'
          id: number
          name: string
          image: { __typename: 'TruckImage'; medium: string }
        }
        menu: {
          __typename: 'Menu'
          id: number
          foodTypes: Array<{
            __typename: 'FoodType'
            id: number
            name: string | null
          }>
        }
        lot: {
          __typename: 'Lot'
          id: number
          nameWithinGroup: string | null
          address: string | null
          fullAddress: string
        }
      }>
    }>
  } | null
  lot: {
    __typename: 'Lot'
    id: number
    subscribed: boolean
    phone: string | null
    email: string | null
    latitude: number
    longitude: number
    name: string
    active: boolean
    lotUrl: string
    lotPath: string
    address: string | null
    fullAddress: string
    facebook: string | null
    instagram: string | null
    twitter: string | null
    tiktok: string | null
    website: string | null
    referralEnabled: boolean
    flyerImage: { __typename: 'LotFlyerImage'; medium: string } | null
    locationSchedule: Array<{
      __typename: 'LocationSchedule'
      id: string
      dateAlias: string
      date: any
      locations: Array<{
        __typename: 'Location'
        id: number
        startTime: any
        endTime: any
        workStatus: Types.LocationWorkStatus
        workStatusHuman: string
        allowOrders: boolean
        customerUrl: string
        truck: {
          __typename: 'Truck'
          id: number
          name: string
          image: { __typename: 'TruckImage'; medium: string }
        }
        menu: {
          __typename: 'Menu'
          id: number
          foodTypes: Array<{
            __typename: 'FoodType'
            id: number
            name: string | null
          }>
        }
        lot: {
          __typename: 'Lot'
          id: number
          nameWithinGroup: string | null
          address: string | null
          fullAddress: string
        }
      }>
    }>
    image: {
      __typename: 'LotImage'
      horizontalStretch: string
      medium: string
      original: string | null
      present: boolean
    } | null
    foodImage: { __typename: 'LotFoodImage'; medium: string } | null
  } | null
  structuredData: {
    __typename: 'StructuredData'
    lotPage: Array<string> | null
  }
}

export const LotScheduleQueryDocument = ({
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LotScheduleQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'seoName' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lotGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'seoName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'seoName' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schedulePath' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'present' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lotGroupUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lotGroupPath' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'flyerImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lots' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'lotBaseFragment' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lotGroupPosition' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latitude' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longitude' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationSchedule' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'days' },
                      value: { kind: 'IntValue', value: '365' }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateAlias' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startTime' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endTime' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workStatus' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workStatusHuman' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allowOrders' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customerUrl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'truck' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'medium'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'menu' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'foodTypes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lot' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nameWithinGroup'
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fullAddress' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'seoName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'seoName' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'lotBaseFragment' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'flyerImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationSchedule' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'days' },
                      value: { kind: 'IntValue', value: '365' }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateAlias' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startTime' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endTime' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workStatus' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'workStatusHuman' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allowOrders' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customerUrl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'truck' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'medium'
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'menu' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'foodTypes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lot' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nameWithinGroup'
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fullAddress' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structuredData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lotPage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'seoName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'seoName' }
                      }
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    ...LotBaseFragment.definitions
  ]
} as unknown) as DocumentNode

/**
 * __useLotScheduleQuery__
 *
 * To run a query within a React component, call `useLotScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotScheduleQuery({
 *   variables: {
 *      seoName: // value for 'seoName'
 *   },
 * });
 */
export function useLotScheduleQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LotScheduleQuery,
    LotScheduleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<LotScheduleQuery, LotScheduleQueryVariables>(
    LotScheduleQueryDocument,
    options
  )
}
export function useLotScheduleQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LotScheduleQuery,
    LotScheduleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LotScheduleQuery,
    LotScheduleQueryVariables
  >(LotScheduleQueryDocument, options)
}
export type LotScheduleQueryHookResult = ReturnType<typeof useLotScheduleQuery>
export type LotScheduleQueryLazyQueryHookResult = ReturnType<
  typeof useLotScheduleQueryLazyQuery
>
export type LotScheduleQueryQueryResult = Apollo.QueryResult<
  LotScheduleQuery,
  LotScheduleQueryVariables
>
